import React from "react";

export interface IconProps extends React.SVGAttributes<HTMLOrSVGElement> {
  size?: number;
}

export const IconCollaborators: React.FC<IconProps> = ({
  size = 20,
  ...rest
}) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M13.6364 6C15.1455 6 16.3545 4.66 16.3545 3C16.3545 1.34 15.1455 0 13.6364 0C12.1273 0 10.9091 1.34 10.9091 3C10.9091 4.66 12.1273 6 13.6364 6ZM6.36364 6C7.87273 6 9.08182 4.66 9.08182 3C9.08182 1.34 7.87273 0 6.36364 0C4.85455 0 3.63636 1.34 3.63636 3C3.63636 4.66 4.85455 6 6.36364 6ZM6.36364 8C4.24545 8 0 9.17 0 11.5V14H12.7273V11.5C12.7273 9.17 8.48182 8 6.36364 8ZM13.6364 8C13.3727 8 13.0727 8.02 12.7545 8.05C13.8091 8.89 14.5455 10.02 14.5455 11.5V14H20V11.5C20 9.17 15.7545 8 13.6364 8Z"
          fill="#616161"
        />
      </svg>
    </>
  );
};
